"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = void 0;
const consolidateErrors_1 = require("./consolidateErrors");
const helpers_1 = require("./helpers");
const validateTransform = (transformation) => {
    try {
        const dataTape = (0, helpers_1.getSanitizeTransformOpOutputDataTape)(transformation);
        return {
            isValid: true,
            data: dataTape,
        };
    }
    catch (error) {
        const metadataError = {
            type: 'metadataValidation',
            message: error instanceof Error
                ? error.message
                : 'Unexpected Error in validateTransform',
        };
        return {
            isValid: false,
            errors: [metadataError],
        };
    }
};
const consolidateFieldErrors = (fieldValidationErrors) => {
    // each FieldValidationError is generated for a row
    // it contains all the fields for which the row failed validation
    // first collect all individual fields that failed validation
    // along with the row number
    const allInvalidFields = fieldValidationErrors.flatMap((error) => error.invalidFields.map((field) => ({ ...field, row: error.row })));
    return (0, consolidateErrors_1.consolidateErrors)(allInvalidFields, (error) => error.name, // Group by field name
    (error) => ({
        value: error.value,
        expectedType: error.expectedType,
        expectedFormat: error.expectedFormat,
        row: String(error.row),
    }), // Map to row data
    (field) => `Field [${field}] had errors`);
};
const consolidateOtherErrors = (unknownErrors) => {
    return (0, consolidateErrors_1.consolidateErrors)(unknownErrors, (error) => error.message, // Group by message
    (error) => ({
        type: error.type,
    }), // Map to row data
    (message) => message);
};
const consolidateToStructuredErrors = (errors) => {
    const fieldErrors = errors.filter((error) => error.type === 'fieldValidation');
    const otherErrors = errors.filter((error) => error.type === 'metadataValidation');
    // we want to consolidate the errors if there are too many of those.
    return [
        ...consolidateFieldErrors(fieldErrors),
        ...consolidateOtherErrors(otherErrors),
    ];
};
const performTransform = async (params) => {
    const { dataTapeBuffers, transformation } = params;
    const srcDataTapeBuffer = dataTapeBuffers[0];
    const result = await (0, helpers_1.sanitizeTransformOp)({
        srcDataTapeBuffer,
        transformation,
    });
    if (result.isValid) {
        return {
            isValid: true,
            data: result.data,
            supplementals: [],
        };
    }
    return {
        isValid: false,
        errors: consolidateToStructuredErrors(result.errors),
    };
};
exports.transformOperation = {
    operation: 'sanitize',
    validateTransform,
    performTransform,
};
//# sourceMappingURL=sanitize-transform.js.map